(function() {
    // Configuration
    const COUNT = 150;
    const COLOR = "rgba(255, 255, 255, 0.8)"; 

    const canvas = document.getElementById('snow-canvas');
    const ctx = canvas.getContext('2d');
    const toggleBtn = document.getElementById('toggle-snow');
    
    let width = window.innerWidth;
    let height = window.innerHeight;
    let particles = [];
    let isSnowing = localStorage.getItem('neige_active') !== 'false';
    let animationId; // Pour stocker l'ID de la frame

    // Redimensionnement
    canvas.width = width;
    canvas.height = height;

    window.addEventListener('resize', () => {
        width = window.innerWidth;
        height = window.innerHeight;
        canvas.width = width;
        canvas.height = height;
    });

    // Classe Flocon (Identique à avant)
    class Snowflake {
        constructor() {
            this.reset();
            this.y = Math.random() * height;
        }
        reset() {
            this.x = Math.random() * width;
            this.y = -10;
            this.size = Math.random() * 2 + 1;
            this.speedY = Math.random() * 1 + 0.5;
            this.speedX = Math.random() * 0.5 - 0.25;
            this.opacity = Math.random() * 0.3+ 0.3;
        }
        update() {
            this.y += this.speedY;
            this.x += this.speedX;
            if (this.y > height) this.reset();
            if (this.x > width || this.x < 0) {
                this.reset();
                this.x = Math.random() * width;
            }
        }
        draw() {
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
            ctx.fillStyle = COLOR;
            ctx.globalAlpha = this.opacity;
            ctx.fill();
            ctx.globalAlpha = 1;
        }
    }

    function init() {
        for (let i = 0; i < COUNT; i++) {
            particles.push(new Snowflake());
        }
        animate();
    }

    function animate() {
        // Si la neige est désactivée, on arrête la boucle ici
        if (!isSnowing) return;

        ctx.clearRect(0, 0, width, height);
        for (let i = 0; i < particles.length; i++) {
            particles[i].update();
            particles[i].draw();
        }
        animationId = requestAnimationFrame(animate);
    }

    // --- Logique du Toggle ---
    toggleBtn.addEventListener('click', () => {
        isSnowing = !isSnowing; // Inverse l'état

        if (isSnowing) {
            // Si on active
            toggleBtn.classList.remove('off');
            toggleBtn.textContent = "❄️"; // Icône neige
            animate(); // On relance la boucle
        } else {
            // Si on désactive
            toggleBtn.classList.add('off'); 
            toggleBtn.textContent = "🚫"; // Icône stop (ou autre)
                    
            // On efface le canvas immédiatement pour que ce soit propre
            ctx.clearRect(0, 0, width, height);
                    
            // On annule la requête d'animation en cours (sécurité supplémentaire)
            cancelAnimationFrame(animationId);
        }
        localStorage.setItem('neige_active', isSnowing);
    });

    // Lancement
    init();

    if (!isSnowing) {
        toggleBtn.classList.add('off');
        toggleBtn.textContent = "🚫";
    }
})();